exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-field[data-v-5ff9965c]{height:100px;width:110px;padding:0 10px}.region-field[data-v-5ff9965c]{width:240px;padding-left:0!important;-webkit-box-flex:initial;-ms-flex:initial;flex:initial}.cant-edit-field[data-v-5ff9965c]{line-height:100px;text-align:center}.regions[data-v-5ff9965c]{border-bottom:1px solid #eee}.cant-edit-region[data-v-5ff9965c]{min-height:100px}.table[data-v-5ff9965c]{margin-left:20px;max-width:1800px;max-height:50%}ul[data-v-5ff9965c]{list-style-type:none}.logo[data-v-5ff9965c]{max-width:118px;vertical-align:middle}.table-data[data-v-5ff9965c]{border-bottom:1px solid #eee}.table-data span[data-v-5ff9965c]{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ff9965c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/b2b/CommissionsAntimite.vue
// module id = RvnQ
// module chunks = 0